import { lazy } from 'react';

export const CreateDeveloperPage = lazy(() =>
  import('./ui/CreateDeveloperPage').then((module) => ({
    default: module.CreateDeveloperPage,
  }))
);
